import autodeskSvgWhiteUrl from '../assets/images/autodesk-svg-white.svg'
import iconUnifierWhite from '../assets/images/icon_unifier_white.png'

import { isAutodeskBuildIntegrationBranding } from './autodeskBuildIntegration'

const VAR = '--integration-rfi-hotspot-icon'

/**
 * Pannellum hotspot classes read `background-image` from SCSS using this CSS variable
 * so the correct icon is used for the current branding build.
 */
export function ensureIntegrationHotspotCssVar(): void {
  if (typeof document === 'undefined') return
  const url = isAutodeskBuildIntegrationBranding
    ? autodeskSvgWhiteUrl
    : iconUnifierWhite
  document.documentElement.style.setProperty(VAR, `url(${JSON.stringify(url)})`)
}
